<template>
  <div>
      <v-toolbar color="highlight" dark dense flat class="sticky">
      <v-toolbar-title>{{$t('reports')}}</v-toolbar-title>
      <v-spacer></v-spacer>
        <v-menu transition="scale-transition" origin="right top" style="z-index: 10" class="white" :close-on-content-click="false" bottom left>
        <template v-slot:activator="{ on }">
          <v-btn color="white" icon v-on="on">
            <v-icon>fa-info-circle</v-icon>
          </v-btn>
        </template>
        <v-sheet flatwidth="600px">
          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">report_problem</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{$t('info_firelog_solutions')}}</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-sheet>
      </v-menu>
    </v-toolbar>
    <!-- <v-card flat> -->
      <v-container class="pa-2" fluid>
        <v-row>
          <v-col sm12 md4 v-for="(report, i) in reports" :key="i">
            <v-card outlined color @click="markerDetails(report)">
              <v-list-item three-line class="pa-0">
                <v-list-item-avatar class="ml-0 mt-0 mb-0" tile size="170" color="grey">
                  <v-img :src="report.image"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <div
                    class="overline mb-4"
                  >{{report.marker.project}} > {{report.marker.buildingComponent}} > {{report.marker.blueprint}}</div>
                  <v-list-item-title
                    class="headline mb-1"
                  >{{ `${$t('marker')}: ${report.marker.number} `}} {{report.marker.label ? ` - ${report.marker.label}`:''}}</v-list-item-title>
                  <v-list-item-subtitle><b class="mr-2">{{$t('name')}} & {{$t('company')}}:</b> {{report.name}} {{report.company}}</v-list-item-subtitle>
                  <v-list-item-subtitle><b class="mr-2">{{$t('email')}}/{{$t('phone')}}:</b>{{report.email}}</v-list-item-subtitle>
                  <v-list-item-subtitle><b class="mr-2">{{$t('date')}}:</b>{{report.date}}</v-list-item-subtitle>
                  <v-list-item-subtitle><b class="mr-2">{{$t('comment')}}:</b>{{report.comment}}</v-list-item-subtitle>
                </v-list-item-content>

                <!-- <v-list-item-avatar tile size="150" color="grey">
                  <v-img :src="report.marker.projectImage"></v-img>
                </v-list-item-avatar>-->
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    <!-- </v-card> -->
  </div>
</template>


<script>
export default {
  name: "Reports",
  data() {
    return {
      todo: [],
      reports: []
    };
  },
  computed: {},
  methods: {
    markerDetails(item) {
      if (this.$can("update", "markers")) {
      this.$http
        .lockBlueprint(item.marker.blueprintId)
        .then(res => {
          this.$router.push({
            name: "MarkerDetails",
            params: { id: item.markerId }
          });
        })
        .catch(err => {
          this.$noty.error(this.$t("error"));
          console.log(err);
        });
      }
      else{
        this.$router.push({
            name: "MarkerDetails",
            params: { id: item.markerId }
          });
      }
    }
  },
  created() {
    this.$http
      .getReports()
      .then(res => {
        this.reports = res.data;
      })
      .catch(err => {
        this.$noty.error(this.$t("error"));
        console.log(err);
      });
  }
};
</script>


// WEBPACK FOOTER //
// src/views/reports/Index.vue